let activeTimer = null;
let activeOwnerId = null;
let activeAttemptCount = 0;

const MAX_FOLLOW_UP_ATTEMPTS = 3;
const FIRST_FOLLOW_UP_DELAY_MS = 15000;
const NEXT_FOLLOW_UP_DELAY_MS = 30000;

const isFollowUpStatus = (syncStatus) => syncStatus && ['syncing', 'delayed'].includes(syncStatus.status);

export const clearDashboardSyncStatusFollowUp = (ownerId = null) => {
   if (ownerId != null && activeOwnerId != null && ownerId !== activeOwnerId) {
      return;
   }

   if (activeTimer) {
      clearTimeout(activeTimer);
   }

   activeTimer = null;
   activeOwnerId = null;
   activeAttemptCount = 0;
};

export const scheduleDashboardSyncStatusFollowUp = ({ ownerId, syncStatus, refreshStatus }) => {
   if (!isFollowUpStatus(syncStatus) || typeof refreshStatus !== 'function') {
      return;
   }

   if (activeOwnerId != null && activeOwnerId !== ownerId) {
      clearDashboardSyncStatusFollowUp();
   }

   if (activeTimer) {
      return;
   }

   if (activeAttemptCount >= MAX_FOLLOW_UP_ATTEMPTS) {
      return;
   }

   activeOwnerId = ownerId;
   activeAttemptCount += 1;

   const delay = activeAttemptCount === 1 ? FIRST_FOLLOW_UP_DELAY_MS : NEXT_FOLLOW_UP_DELAY_MS;

   activeTimer = setTimeout(() => {
      activeTimer = null;
      refreshStatus();
   }, delay);
};
